import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EngineService } from '../_services/engine.service';
import { ServiceType } from '../_models/ServiceType';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { CueConfig } from '../_models/CueConfig';

@Component({
  templateUrl: './engine-create-modal.component.html',
  styleUrls: ['./engine-create-modal.component.css']
})

export class EngineCreateModalComponent implements OnInit {

  public loading = false;
  public useDefaultConfig = false;
  public form: FormGroup;

  public serviceTypes: ServiceType[] = [];
  public configs: CueConfig[] = [];
  public selectedServiceTypeIds: number[] = [];

  public engine;
  engineId = -1;

  @Output() hasError = new EventEmitter();

  constructor(
    private bsModalRef: BsModalRef,
    private engineService: EngineService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService) { }

  close() {
    this.bsModalRef.hide();
  }

  saveAndClose() {
    if (!this.form.valid) {
      return;
    }

    // cueaudio.com-shared-configs:engine-configs/2019-04-18--calib-3.jso
    const config = this.configs.find(c => c.cueConfigId === this.form.controls.engineConfigId.value);
    const configObjectPath = `${config.bucketName}:${config.path}/${config.name}`;

    this.loading = true;
    this.spinner.show();
    const newEngine = {
      applicationName: this.form.controls.applicationName.value,
      apiKey: this.form.controls.apiKey.value,
      config: configObjectPath,
      notes: this.form.controls.notes.value,
      engineId: this.engineId,
      serviceTypeIds: this.selectedServiceTypeIds,
      playStoreId: this.form.controls.playStoreId.value,
      appleStoreName: this.form.controls.appleStoreName.value,
      appleStoreId: this.form.controls.appleStoreId.value,
      cueConfigId: this.form.controls.engineConfigId.value,
      imageSegmentStartTimeThreshold: this.form.controls.imageSegmentStartTimeThreshold.value
    };

    this.engineService.createEngine(newEngine)
      .subscribe(() => {
        this.loading = false;
        this.spinner.hide();
        this.hasError.emit(false);
        this.bsModalRef.hide();
      }, error => {
        this.loading = false;
        this.spinner.hide();
        this.hasError.emit(false);
        this.bsModalRef.hide();
      });
  }

  compare(val1, val2) {
    return val1 === val2;
  }

  toggleServiceTypeSelect(serviceTypeId: number) {
    const index = this.selectedServiceTypeIds.indexOf(serviceTypeId);
    if (index > -1) {
      this.selectedServiceTypeIds.splice(index, 1);
    } else {
      this.selectedServiceTypeIds.push(serviceTypeId);
    }
  }

  private initForm() {
    this.form = this.fb.group({
      applicationName: ['', Validators.required],
      apiKey: ['', Validators.required],
      playStoreId: [''],
      appleStoreName: [''],
      appleStoreId: [''],
      notes: [],
      engineConfigId: [0, [Validators.required, Validators.min(1)]],
      imageSegmentStartTimeThreshold: [0, [Validators.required, Validators.min(0), Validators.max(60)]]
    });

  }

  generateApiKey() {
    const newApiKey = [];
    const possibleChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 32; i++) {
      newApiKey.push(possibleChars.charAt(Math.floor(Math.random() * possibleChars.length)));
    }
    this.form.controls.apiKey.patchValue(newApiKey.join(''));
  }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.initForm();

    const configObs = this.engineService.getConfigs();
    const serviceTypesObs = this.engineService.getEngineServiceTypes();
    forkJoin([serviceTypesObs, configObs]).subscribe(data => {
      this.serviceTypes = data[0];
      this.configs = data[1];
      this.configs = this.configs.filter(c => c.name !== 'appData.json' && c.name !== '.DS_Store');
      if (this.engine != null) {
        let configName: string = this.engine.config;
        configName = configName.split('/').pop();
        this.form.controls.applicationName.patchValue(this.engine.applicationName);
        this.form.controls.apiKey.patchValue(this.engine.apiKey);
        this.form.controls.playStoreId.patchValue(this.engine.playStoreId);
        this.form.controls.appleStoreName.patchValue(this.engine.appleStoreName);
        this.form.controls.appleStoreId.patchValue(this.engine.appleStoreId);
        this.form.controls.engineConfigId.patchValue(this.engine.cueConfigId);
        this.form.controls.imageSegmentStartTimeThreshold.patchValue(this.engine.imageSegmentStartTimeThreshold);

        this.form.controls.notes.patchValue(this.engine.notes);
        this.engineId = this.engine.engineId;
        this.engine.serviceTypeIds.forEach(typeId => {
          this.selectedServiceTypeIds.push(typeId);
        });
      } else {
        this.serviceTypes.forEach(type => {
          this.selectedServiceTypeIds.push(type.serviceTypeId);
        });
      }

    this.loading = false;
    this.spinner.hide();

    });


  }
}

